@let currentApp = (currentApp$ | async) || (currentAppConfig$ | async);
<div
  class="text-white rounded bg-error text-xl px-3 py-1 items-center admin-message lg:flex hidden flex-1 mx-2 overflow-hidden"
  role="status"
>
  <div class="flex items-center w-full min-w-0">
    <span class="whitespace-nowrap text-xs flex-shrink-0">⚠️ admin mode</span>

    @if (currentApp) {
      <span class="w-px h-5 bg-white/30 mx-2 flex-shrink-0"></span>
      <img
        [src]="logoUrl(currentApp)"
        alt=""
        class="w-6 h-6 rounded object-cover bg-white/10 flex-shrink-0"
      />
      <div class="flex items-center ml-2 gap-2 min-w-0 flex-1">
        <span class="text-xs truncate min-w-0">{{ currentApp.name || currentApp.nomRadio }}</span>
        @if (planName(currentApp)) {
          <span class="text-xs px-2 py-0.5 rounded bg-white/20 text-white border border-white/40 flex-shrink-0">
            {{ planName(currentApp) }}
          </span>
        }
      </div>
    }

    <button
      type="button"
      class="ml-3 px-2 py-1 cursor-pointer text-xs bg-white text-black rounded flex-shrink-0"
      (click)="resetCurrentApp()"
      aria-label="retour"
    >
      retour
    </button>
  </div>
</div>
